// import { routerMainPageName } from '@/router/router.constants';
import { StoreInstance } from '@quasar/app-webpack';
import { Store } from 'pinia';
import { boot } from 'quasar/wrappers';
import { ROLE_USER } from 'SharedDir/constants/role';
import { SystemUser } from 'SharedDir/declarations/user';
import { OnlyAuthorized } from 'SharedDir/router/helpers';
import { useAuthStore } from 'SharedDir/stores/auth.store';
import { useUserStore } from 'SharedDir/stores/user.store';
import { useAppStore } from 'stores/app';
import { useRoute } from 'vue-router';

export const checkCurrentProfile = (userStore: ReturnType<typeof useUserStore>): boolean => {
  console.debug('Checking user profile');
  const { currentProfile } = userStore;
  const { roleId } = userStore.user || {};
  // Если у нас обычный пользователь идет куда-то, кроме главной страницы и страниц связанных с авторизацией
  // без выбранного профиля, то перенаправляем на главную где его уже будет ждать модалка с доступными профилями.
  return roleId !== ROLE_USER.id || !!currentProfile;
};

function friendlyLogout(redirectTo) {
  const query = { redirectTo };
  if (process.env.SERVER) {
    return { name: 'main', query };
  }
  return { query };
}

export default boot(({ router, store }) => {
  router.beforeResolve(async (to, from) => {
    const userStore = useUserStore();
    const authStore = useAuthStore();
    const appStore = useAppStore();
    const route = useRoute();
    const noAuth = (m?: OnlyAuthorized) => !m || (m && !m.authorization);
    const { meta } = to;
    if (noAuth(meta)) {
      // Если роут не имеет пометку только авторизованным, то все ОК, пропускаем
      console.debug('Public route', to.path);
      return;
    }

    const { isAuthenticated } = authStore;
    const { user } = userStore;
    // Если такая пометка есть, то проверяем вообще что пользователь авторизован,
    // если в качестве значения у флага авторизации представлен
    // массив идентификаторов разрешенных ролей, то сравниваем еще и это.
    const authFits = (m: OnlyAuthorized) =>
      (typeof m.authorization === 'boolean' && m.authorization) ||
      (Array.isArray(m.authorization) &&
        m.authorization.includes((user as SystemUser).roleId as number));

    if (!(isAuthenticated && authFits(meta as OnlyAuthorized))) {
      console.debug('Private route, guest.', to.path);
      const redirectTo = to.fullPath;
      setTimeout(() => {
        appStore.showAuthDialog();
      }, 300);
      // eslint-disable-next-line consistent-return
      return friendlyLogout(redirectTo);
    }

    console.debug('Private route, auth user.');

    // if (!checkCurrentProfile(userStore)) {
    //   appStore.showProfileDialog();
    // }
  });
});
